<script lang="ts">
	import { Icon, Text } from '@Shelly/shelly-design-system';
	import { classMap } from '@Shelly/shelly-design-system/helpers/component-utils';
	import MqttIcon from './MqttIcon.svelte';
	import { onDestroy } from 'svelte';
	import { user_data } from 'src/stores/account/user';
import { devices_status } from 'src/stores/device-runtime/status';
	import { getDateByTimeZone, getTimeFormat, time_zones } from 'src/helpers/date_helper';

	export let icons;
	export let id: string;
	export let deviceSettings;

	let hideClock: boolean = false;
	let formattedTime: string;
	let intervalId: ReturnType<typeof setInterval>;
	let timeoutId: ReturnType<typeof setTimeout>;

	const minuteInSeconds = 60;
	const secondInMiliseconds = 1000;
	const clockOptions: {
		timeZone: string;
		hour: '2-digit' | 'numeric';
		minute: '2-digit' | 'numeric';
		hour12: boolean;
	} = {
		timeZone: null,
		hour: '2-digit',
		minute: '2-digit',
		hour12: false,
	};

	$: (deviceSettings, getDeviceStatusAndTimeZone());

	onDestroy(() => {
		clearInterval(intervalId);
		clearTimeout(timeoutId);
	});

	function getDeviceStatusAndTimeZone() {
		if (deviceSettings) {
			if (deviceSettings.timezone) {
				clockOptions.timeZone = deviceSettings.timezone;
			} else {
				clockOptions.timeZone = deviceSettings.sys?.location?.tz
					? deviceSettings.sys.location.tz
					: null;
			}
		}

		if (!time_zones.includes(clockOptions?.timeZone)) {
			clockOptions.timeZone = $user_data.timezone;
		}

		checkToHideClock();

		if (!hideClock) {
			setClockTime();
			updateClock();
		}
	}

	function setClockTime() {
		const time: Date = getDateByTimeZone(clockOptions.timeZone);
		formattedTime = getTimeFormat(time.getHours(), time.getMinutes());
	}

	// function setClockTime() {
	// 	const time = new Date().toLocaleString([], clockOptions).split(':');
	// 	const hours = Number(time[0]);
	// 	const minutes = Number(time[1].replace(/[^0-9]/gi, '')); //because of some android devices new Date().toLocaleString() returns spaces and letters instead of numbers only
	// 	formattedTime = getTimeFormat(
	// 		hours > 23 ? 0 : hours, //for some reason new Date().toLocaleString() function returns 24 as hour on android devices so overriding this as Zero and we are good now
	// 		minutes
	// 	);
	// }

	function updateClock() {
		const seconds = new Date().getSeconds();
		const timeUntilNextMinute = (minuteInSeconds - +seconds) * 1000;

		if (timeoutId) {
			clearTimeout(timeoutId);
		}

		timeoutId = setTimeout(() => {
			setClockTime();
			setClockInterval();
		}, timeUntilNextMinute);
	}

	function setClockInterval() {
		if (intervalId) {
			clearInterval(intervalId);
		}

		intervalId = setInterval(() => {
			setClockTime();
		}, minuteInSeconds * secondInMiliseconds);
	}

	function checkToHideClock() {
		let deviceStatus = devices_status.getByRealId(id);

		if (icons.length > 0 && deviceStatus !== undefined && isValidTimeZone()) {
			hideClock = false;
		} else {
			hideClock = true;
		}
	}

	function isValidTimeZone() {
		return clockOptions.timeZone !== null && typeof clockOptions.timeZone === 'string';
	}
</script>

{#if !hideClock}
	<Text styleType="tiny">{formattedTime}</Text>
{/if}

{#each icons as icon}
	{#if icon.icon !== 'mqtt'}
		<Icon icon={icon.icon} class="{classMap({ 'text-color-3': !icon.active })} ml-s" size="xs" />
	{:else}
		<!-- this is needed because font awesome doesn't have that icon -->
		<MqttIcon active={icon.active} size={12} className="ml-s mt-xxs" />
	{/if}
{/each}
